export default "__VITE_ASSET__2mGw2qkp__"